import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IAddUsersToSiteParams {
  usernames: string[]; // 'possibly qualified user names'
  siteRole: string;
}

export interface IAddUsersToSiteResult extends IResult {
}

export class AddUsersToSiteRequest extends Request<IAddUsersToSiteParams, IAddUsersToSiteResult> {
  constructor(usernames: string[], siteRole: string) {
    super('addUsersToSite', { usernames: usernames, siteRole: siteRole });
  }
}
